import React from 'react';
import type { ToastContentProps } from 'react-toastify';
import { CheckCircle, X, XCircle, WarningCircle } from '@phosphor-icons/react';

const iconMap = {
  success: (
    <>
      <CheckCircle size={24} color="#4bbd92" weight="fill" className="tablet:hidden" />
      <CheckCircle size={32} color="#4bbd92" weight="fill" className="hidden tablet:block" />
    </>
  ),
  error: (
    <>
      <XCircle color="#CB3636" size={24} weight="fill" className="tablet:hidden" />
      <XCircle color="#CB3636" size={32} weight="fill" className="hidden tablet:block" />
    </>
  ),
  warning: (
    <>
      <WarningCircle color="#FFD642" size={24} weight="fill" className="tablet:hidden" />
      <WarningCircle color="#FFD642" size={32} weight="fill" className="hidden tablet:block" />
    </>
  ),
};

interface ToastProps extends ToastContentProps {
  data: {
    title: string;
    message: string;
  };
}

const Toast: React.FC<ToastProps> = ({ closeToast, toastProps, data }) => {
  const icon = iconMap[toastProps.type as keyof typeof iconMap] || null;

  return (
    <div className="flex items-center justify-between gap-16 w-full">
      <div className="flex-1">
        <div className="flex items-center px-16 py-12 tablet:pr-20 tablet:pt-16">
          {icon}

          <p className="text-body text-ashgray ml-8">{data?.title || 'Success'}</p>
          <X onClick={closeToast} color="#7c6d65" size={19.21} className="ml-auto tablet:hidden" />
          <X
            onClick={closeToast}
            color="#7c6d65"
            size={25.6}
            className="ml-auto hidden tablet:block"
          />
        </div>

        <p className="text-body-sm tablet:text-body-xs text-silver bg-off-gray-soft p-16 pt-12 tablet:p-20 tablet:pt-16">
          {data?.message}
        </p>
      </div>
    </div>
  );
};

export default Toast;
